/**
 * Cookie Policy / Cookiepolicy
 * Source: /Information/Terms/cookie_policy_v1_*.md
 */

export const cookiePolicySV = `# Cookiepolicy för Beredskapshubben

**Senast uppdaterad:** 2026-03-07

Denna cookiepolicy förklarar hur Beredskapshubben använder cookies och liknande tekniker på vår webbplats.

Mobilappen använder inte traditionella cookies, men kan använda liknande tekniker för funktion och analys.

Webbappen kan även använda webblagring (t.ex. localStorage och sessionStorage) för nödvändiga funktioner som inloggning och inställningar.

---

## 1. Vad är cookies?

Cookies är små textfiler som lagras i din webbläsare när du besöker en webbplats. De används för att:

* få webbplatsen att fungera
* komma ihåg inställningar
* förbättra användarupplevelsen
* analysera användning
* skydda säkerheten

---

## 2. Typer av cookies vi använder

### Nödvändiga cookies

Krävs för att tjänsten ska fungera.

Används för:

* inloggning
* sessionshantering
* säkerhet
* belastningsskydd

Dessa kan inte stängas av.

---

### Funktionella cookies

Används för att spara val och inställningar.

Exempel:

* språkval
* användarinställningar
* gränssnittspreferenser

---

### Analyscookies

Används för att förstå hur tjänsten används.

Exempel:

* sidvisningar
* funktionsanvändning
* fel och prestanda

Där möjligt används aggregerad eller pseudonymiserad data.

---

### Säkerhetscookies

Används för att:

* upptäcka missbruk
* förhindra attacker
* skydda konton

---

## 3. Tredjepartscookies

Vi kan använda tredjepartstjänster för:

* drift
* analys
* felrapportering

Dessa leverantörer behandlar data enligt avtal med oss.

---

## 4. Samtycke

Där lag kräver inhämtar vi samtycke för icke-nödvändiga cookies via cookie-banner.

Nödvändiga cookies och nödvändig webblagring används utan samtycke eftersom de krävs för att tjänsten ska fungera.

Du kan när som helst ändra ditt samtycke.

---

## 5. Hur du kontrollerar cookies

Du kan styra cookies via din webbläsare:

* blockera cookies
* radera cookies
* ställa in varningar

Observera att vissa funktioner kan sluta fungera.

---

## 6. Kontakt

[privacy@beredskapshubben.se](mailto:privacy@beredskapshubben.se)

---`;

export const cookiePolicyEN = `# Cookie Policy – Beredskapshubben

**Last updated:** 2026-03-07

This Cookie Policy explains how Beredskapshubben uses cookies and similar technologies on our website.

The mobile app does not use traditional cookies but may use similar technologies for functionality and analytics.

The web app may also use browser storage (e.g., localStorage and sessionStorage) for necessary functions such as authentication and settings.

---

## 1. What Are Cookies?

Cookies are small text files stored in your browser when visiting a website. They are used to:

* enable functionality
* remember settings
* improve user experience
* analyze usage
* enhance security

---

## 2. Types of Cookies We Use

### Necessary Cookies

Required for the Service to function.

Used for:

* login
* session handling
* security
* load protection

Cannot be disabled.

---

### Functional Cookies

Used to remember preferences such as:

* language
* user settings
* interface choices

---

### Analytics Cookies

Used to understand how the Service is used.

Examples:

* page usage
* feature usage
* performance metrics
* error tracking

Where possible, data is aggregated or pseudonymized.

---

### Security Cookies

Used to:

* detect abuse
* prevent attacks
* protect accounts

---

## 3. Third-Party Cookies

We may use third-party providers for:

* infrastructure
* analytics
* error reporting

They process data under contract with us.

---

## 4. Consent

Where required by law, we collect consent for non-essential cookies via a cookie banner.

Necessary cookies and necessary browser storage are used without consent because they are required for the Service to function.

Consent can be changed at any time.

---

## 5. Managing Cookies

You can control cookies through your browser settings:

* block cookies
* delete cookies
* set alerts

Some features may stop working.

---

## 6. Contact

[privacy@beredskapshubben.se](mailto:privacy@beredskapshubben.se)

---`;
